module.exports = __webpack_public_path__ + "img/i-clock-mono.2a21262f.svg";